export const KpiCard = ({ icon: Icon, label, value, sub, tone = "amber", testId, unit }) => {
  const tones = {
    amber: "from-amber-500/10 to-amber-500/0 border-amber-500/30 text-amber-300",
    emerald: "from-emerald-500/10 to-emerald-500/0 border-emerald-500/30 text-emerald-300",
    rose: "from-rose-500/10 to-rose-500/0 border-rose-500/30 text-rose-300",
    sky: "from-sky-500/10 to-sky-500/0 border-sky-500/30 text-sky-300",
    slate: "from-slate-500/10 to-slate-500/0 border-slate-500/30 text-slate-300",
  };
  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden rounded-xl border bg-gradient-to-br ${tones[tone]} bg-[#111D38]/70 backdrop-blur-md p-4 sm:p-5 transition-all hover:-translate-y-0.5 hover:shadow-[0_10px_30px_-10px_rgba(245,158,11,0.25)]`}
    >
      <div className="flex items-start justify-between mb-3">
        <span className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold">{label}</span>
        <div className={`h-9 w-9 rounded-lg flex items-center justify-center bg-white/5 ${tones[tone].split(" ").find(c => c.startsWith("text-"))}`}>
          <Icon className="h-4 w-4" />
        </div>
      </div>
      <div className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-50">{value}{unit && <span className="ml-1.5 text-xs sm:text-sm font-medium tracking-normal text-slate-400">{unit}</span>}</div>
      {sub && <div className="mt-1 text-xs text-slate-400">{sub}</div>}
      <div className="absolute -right-8 -bottom-8 h-24 w-24 rounded-full bg-white/5 blur-2xl" />
    </div>
  );
};
